import uiCommonMutations from '@/store/ui/common/mutations'
import Vue from 'vue'

const mutations = {
    ...uiCommonMutations,

    setFormAction(state, action) {
        Vue.set(state.form, 'action', action)
    },

    setForm(state, newPoint) {
        Vue.set(state.form, 'point', newPoint)
    },

    setFormField(state, { field, value }) {
        Vue.set(state.form.point, field, value)
    },

    setFormUpdateInfos(state, { index }) {
        Vue.set(state.form, 'index', index)
    },

    setFocusedPoint(state, { index, shouldFly = true, shouldScroll = true, shouldFlyEvenIfInMap = false }) {
        Vue.set(state.focusedPoint, 'index', index)
        Vue.set(state.focusedPoint, 'shouldFly', shouldFly)
        Vue.set(state.focusedPoint, 'shouldScroll', shouldScroll)
        Vue.set(state.focusedPoint, 'shouldFlyEvenIfInMap', shouldFlyEvenIfInMap)
    }
}

export default mutations
